import { render, staticRenderFns } from "./StorehouseList.vue?vue&type=template&id=3941ea40&scoped=true&"
import script from "./StorehouseList.vue?vue&type=script&lang=js&"
export * from "./StorehouseList.vue?vue&type=script&lang=js&"
import style0 from "./StorehouseList.vue?vue&type=style&index=0&id=3941ea40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3941ea40",
  null
  
)

export default component.exports